module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/news/buisson_jeunes_ete2008_1000x750.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("SHDL: Simple Hardware Description Language")]), _vm._v(" "), _c('div', [_vm._v("\n             SHDL is a language for describing digital circuits in a simple and modular way.\n             It is not a programming language; rather it allows for the description of the various equipotentials which compose a circuit\n             and their combinatorial or sequential relationships.\n             Once a design has been described correctly in SHDL, it can be 'powered up' and run (by simulation or by synthesis in a real FPGA circuit)\n          ")])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fbcd904","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/SHDLNews.vue
// module id = 1171
// module chunks = 1